export const admisionRoutes = [
  {
    path: '/admisiones/create',
    name: 'AdmisionCreate',
    desplegable: false,
    icon: 'mdiAccountArrowRight',
    typeIcon: 'mdi',
    menu: true,
    replace: true,
    meta: {
      permiso: ['agendarConsultas'],
      perfiles: ['ADMISIONES', 'PROCEDIMIENTOS'],
      title: 'Ingreso rápido',
      subTitle: 'Admisionar paciente',
      requiresSession: true,
      showBackButton: false,
      forceRemount: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionForm.vue'
      )
  },
  {
    path: '/admisiones/from-cita/:id',
    name: 'AdmisionFromCita',
    desplegable: false,
    icon: 'mdiAccountArrowRight',
    typeIcon: 'mdi',
    menu: false,
    replace: true,
    meta: {
      forceRemount: true,
      perfiles: ['ADMISIONES'],
      permiso: ['agendarConsultas'],
      title: 'Admisionar Cita',
      subTitle: 'Admisionar paciente desde cita',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionForm.vue'
      )
  },
  {
    path: '/admisiones/from-orden/:sessionId?',
    name: 'AdmisionFromOrden',
    desplegable: false,
    icon: 'mdiAccountArrowRight',
    typeIcon: 'mdi',
    menu: false,
    replace: true,
    meta: {
      forceRemount: true,
      perfiles: ['ADMISIONES', 'PROCEDIMIENTOS', 'LABORATORIOS'],
      permiso: ['agendarConsultas'],
      title: 'Admisionar Orden',
      subTitle: 'Admisionar paciente desde orden',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionForm.vue'
      )
  },
  {
    path: '/admisiones/edit/:ciadId',
    name: 'AdmisionEdit',
    desplegable: false,
    icon: 'mdiAccountArrowRight',
    typeIcon: 'mdi',
    menu: false,
    replace: true,
    meta: {
      forceRemount: true,
      perfiles: ['ADMISIONES', 'PROCEDIMIENTOS', 'LABORATORIOS'],
      permiso: ['agendarConsultas', 'editarAdmision'],
      title: 'Editar Admisión',
      subTitle: 'Editar una admisión existente',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionForm.vue'
      )
  },
  {
    path: '/admisiones/from-dispensario/:sessionDispId?',
    name: 'AdmisionFromDispensario',
    desplegable: false,
    icon: 'mdiAccountArrowRight',
    typeIcon: 'mdi',
    menu: false,
    replace: true,
    meta: {
      forceRemount: true,
      perfiles: ['FARMACIA'],
      permiso: ['agendarConsultas'],
      title: 'Dispensario',
      subTitle: 'dispensacion de medicamentos',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionDispensarioForm.vue'
      )
  },
  {
    path: '/admisiones/ordenes',
    name: 'AdmisionOrdenesView',
    desplegable: false,
    icon: 'mdiAccountHeartOutline',
    typeIcon: 'mdi',
    menu: true,
    meta: {
      perfiles: ['ADMISIONES', 'PROCEDIMIENTOS', 'LABORATORIOS'],
      permiso: ['agendarConsultas', 'admisionarConsultas'],
      title: 'Ordenes médicas',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Ordenes/OrdenesIndex.vue'
      )
  },
  {
    path: '/admisiones/ordenes/:ciotId',
    name: 'AdmisionOrdenesDetailView',
    desplegable: false,
    icon: 'mdiAccountHeartOutline',
    typeIcon: 'mdi',
    menu: false,
    meta: {
      perfiles: ['ADMISIONES', 'PROCEDIMIENTOS', 'LABORATORIOS', 'FARMACIA'],
      permiso: ['agendarConsultas', 'admisionarConsultas'],
      title: 'Ordenes médicas',
      subTitle: 'Detalles de la orden médica',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Ordenes/OrdenesView.vue'
      )
  },
  {
    path: '/admisiones/ordenes/:tipo/:ciotId',
    name: 'AdmisionOrdenesAgendarForm',
    desplegable: false,
    icon: 'mdiAccountHeartOutline',
    typeIcon: 'mdi',
    menu: false,
    meta: {
      permiso: [],
      perfiles: ['ADMISIONES'],
      title: 'Agendamiento de ordenes médicas',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Ordenes/OrdenesAgendarForm.vue'
      )
  },
  {
    path: '/ingresos',
    name: 'AdmisionIndex',
    desplegable: false,
    icon: 'mdiCalendarAccountOutline',
    typeIcon: 'mdi',
    menu: true,
    replace: true,
    meta: {
      permiso: [],
      perfiles: [
        'PACIENTE',
        'ADMISIONES',
        'PROCEDIMIENTOS',
        'LABORATORIOS',
        'COORDINADOR ASISTENCIAL'
      ],
      title: 'Ingresos y citas',
      subTitle: 'Lista de ingresos y citas',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionIndex.vue'
      )
  },
  {
    path: '/ingreso/:ciadId',
    name: 'AdmisionView',
    desplegable: false,
    icon: 'mdiCalendarAccountOutline',
    typeIcon: 'mdi',
    menu: false,
    replace: true,
    meta: {
      permiso: [],
      perfiles: [
        'ADMISIONES',
        'PROCEDIMIENTOS',
        'LABORATORIOS',
        'COORDINADOR ASISTENCIAL'
      ],
      title: 'Admisión',
      subTitle: 'Detalles de la admisión',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Admision/views/Admision/AdmisionView.vue'
      )
  }
]
